import React, { useState } from "react";
import { twMerge } from "tailwind-merge";
import ChatFAB from "./ChatFAB";
import ChatHeader from "./ChatHeader";
import ChatMessageList from "./ChatMessageList";
import ChatInputBar from "./ChatInputBar";
import CallStatusPanel from "./CallStatusPanel";
import type { CallState, ChatMessage } from "../../store/@types/chat";

const INITIAL_MESSAGES: ChatMessage[] = [
  {
    id: "intro",
    role: "assistant",
    content:
      "Hi — I'm the Elite Corporate Setup assistant. Ask me about company registration, compliance, our plans, or how to use this site. You can type, or tap the phone icon for a live voice call.",
  },
];

const ChatWidget: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [callState, setCallState] = useState<CallState>("idle");
  const [messages, setMessages] = useState<ChatMessage[]>(INITIAL_MESSAGES);

  const handleToggle = () => setIsOpen((prev) => !prev);

  const handleSendMessage = (content: string) => {
    const userMessage: ChatMessage = {
      id: `${Date.now()}-user`,
      role: "user",
      content,
    };
    setMessages((prev) => [...prev, userMessage]);

    // Placeholder response — wire this up to your AI backend.
    window.setTimeout(() => {
      const assistantMessage: ChatMessage = {
        id: `${Date.now()}-assistant`,
        role: "assistant",
        content:
          "Let me look into that for you and get back with the specifics.",
      };
      setMessages((prev) => [...prev, assistantMessage]);
    }, 500);
  };

  const handleStartCall = () => {
    setCallState("connecting");
    // Replace with your real call-connect flow (e.g. WebRTC/voice SDK
    // handshake); flip to "listening" once the line is actually live.
    window.setTimeout(() => setCallState("listening"), 1800);
  };

  const handleEndCall = () => setCallState("idle");

  return (
    <>
      <ChatFAB callState={callState} onClick={handleToggle} />

      {isOpen && (
        <div
          className={twMerge(
            "fixed bottom-40 right-4 z-40 flex max-h-[70vh] w-[calc(100vw-2rem)] flex-col overflow-hidden rounded-2xl bg-white border border-white shadow-2xl shadow-slate-900/20 sm:bottom-40 sm:right-6 sm:w-96",
          )}
        >
          <ChatHeader
            callState={callState}
            onStartCall={handleStartCall}
            onEndCall={handleEndCall}
            onClose={() => setIsOpen(false)}
          />

          {callState === "idle" ? (
            <>
              <ChatMessageList messages={messages} />
              <ChatInputBar onSend={handleSendMessage} />
            </>
          ) : (
            <CallStatusPanel callState={callState} />
          )}
        </div>
      )}
    </>
  );
};

export default ChatWidget;
